import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateRangePickerWrapper from '../../DatePicker/DateRangePickerWrapper';
import './index.css';

class FilterPeriod extends React.Component {
    constructor(props) {
        super(props);
        this.state = { end: props.initialValues.end, start: props.initialValues.start }
    }

    onDatesChange({ startDate, endDate }) {
        const newState = {
            start: moment(startDate).format('YYYY-MM-DD'),
            end: moment(endDate).format('YYYY-MM-DD')
        };
        this.setState(newState);
        this.props.onChange(newState);
    }

    render() {
        const { buttonGroup, datePickerProps, label } = this.props;
        const { end, start } = this.state;

        return (
            <div className="period-filter inline">
                {label && [<label key="period-filter-label-1">{label}</label>, <br key="period-filter-label-2"/>]}
                <div className={classNames('inline data-range-picker', { fullBorderedInput: !buttonGroup })}>
                    <DateRangePickerWrapper
                        initialStartDate={start && moment(start)}
                        initialEndDate={end && moment(end)}
                        onDatesChange={(dates) => this.onDatesChange(dates)}
                        { ...datePickerProps }
                    />
                    {buttonGroup && (
                        <button
                            onClick={() => buttonGroup.onClick(this.state)}
                            className={classNames('btn', {
                                'btn-default': !buttonGroup.className && !buttonGroup.type,
                                [`btn-${buttonGroup.type}`]: buttonGroup.type,
                            })}
                        >
                            <i className={buttonGroup.icon}/>
                        </button>
                    )}
                </div>
            </div>
        )
    }
}

FilterPeriod.propTypes = {
    buttonGroup: PropTypes.shape({
        className: PropTypes.string,
        icon: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        type: PropTypes.string,
    }),
    datePickerProps: PropTypes.object,
    initialValues: PropTypes.shape({
        end: PropTypes.string, // date
        start: PropTypes.string, // date
    }),
    onChange: PropTypes.func.isRequired,
};

FilterPeriod.defaultProps = {
    buttonGroup: null,
    datePickerProps: { minimumNights: 0 },
    initialValues: {
        end: null,
        start: null,
    },
};

export default FilterPeriod



// WEBPACK FOOTER //
// ./src/components/Filters/Period/index.js